var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "eye-closed_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.076 12c.833-4.534 5.38-8 10.864-8s10.031 3.466 10.864 8c-.833 4.534-5.38 8-10.864 8S2.91 16.534 2.076 12",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.076 12 .11 11.639.043 12l.066.361zm21.728 0 1.967.361.066-.361-.066-.361zm-19.76.361C4.669 8.958 8.224 6 12.94 6V2C6.687 2 1.15 5.974.11 11.639zM12.94 6c4.716 0 8.272 2.958 8.897 6.361l3.934-.722C24.73 5.974 19.193 2 12.94 2zm8.897 5.639C21.212 15.042 17.656 18 12.94 18v4c6.253 0 11.79-3.974 12.83-9.639zM12.94 18c-4.716 0-8.271-2.958-8.896-6.361l-3.935.722C1.15 18.026 6.687 22 12.94 22z",
    mask: "url(#eye-closed_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.94 19h2v4h-2zM20.892 15.166l.517-1.932 3.864 1.035-.517 1.932zM4.471 13.234l.518 1.932L1.125 16.2.607 14.27zM16.408 18.162l1.587-1.217 2.739 3.57-1.587 1.217zM7.886 16.945l1.586 1.218-2.739 3.57-1.587-1.218z"
  })));
};
export default SvgEyeClosed;